import { Request } from "../stores/Requests20";
import { url as encodeUrl } from "../utils/UrlUtil";
import { handleServiceResponse } from "./ServerRequestsInternal";
import type { ArticleData } from "../model/ArticleTypes";
import type { AnonCartContext } from "../model/AnonCartTypes";
const BASE_URL = "/ordercapture/anonymouscart/articles";
const TIMEOUT = 5000;
export async function getAnonCartArticleData(
	cartContext: AnonCartContext,
	bundleIds: string[],
): Promise<Map<string, ArticleData>> {
	const url =
		BASE_URL +
		encodeUrl`?country=${cartContext.country}&locale=${cartContext.locale}&storeId=${cartContext.storeId}&` +
		bundleIds.map((bundleId) => encodeUrl`bundleIds=${bundleId}`).join("&");
	const response = Request.get(url).timeout(TIMEOUT).execute();
	const json = await handleServiceResponse(response);

	if (!json.data || !json.data.data) {
		return new Map();
	}

	const entries: Array<[string, ArticleData]> = [];

	for (const bundleId in json.data.data) {
		if (!Object.hasOwn(json.data.data, bundleId)) {
			continue;
		}

		entries.push([bundleId, json.data.data[bundleId]]);
	}

	return new Map(entries);
}
